import { useSelector } from "react-redux";
import { AppState } from "../store";

const getUnreadMessagesCount = () => {
    const unreadMessagesValues = Object.values(useSelector((state: AppState) => state.unreadMessages));
    return unreadMessagesValues.length < 1 ? 0 : unreadMessagesValues.reduce((a, b) => a + b);
};

export default getUnreadMessagesCount;